if (!customElements.get('wishlist-button')) {
  class WishlistButton extends HTMLElement {
    constructor() {
      super();
      this.key = 'wishlist-handles';
      this.handle = this.dataset.productHandle;
      this.button = this.querySelector('button');
      this.button.addEventListener('click', this.onButtonClick.bind(this));
    }

    connectedCallback() {
      this.toggleState();
    }

    onButtonClick(event) {
      event.preventDefault();

      if (!localStorage.getItem(this.key)) {
        localStorage.setItem(this.key, this.handle);
        this.toggleState();
        return;
      }

      const handles = localStorage.getItem(this.key).split(',');

      if (handles.includes(this.handle)) {
        localStorage.setItem(
          this.key,
          handles.filter((foundHandle) => foundHandle !== this.handle)
        );
        if (localStorage.getItem(this.key) === '')
          localStorage.removeItem(this.key);
        this.toggleState();
        return;
      }

      handles.unshift(this.handle);
      localStorage.setItem(this.key, handles);
      this.toggleState();
    }

    isInWishlist() {
      const handles = localStorage.getItem(this.key);
      if (!handles) return false;
      return handles.split(',').includes(this.handle);
    }

    toggleState() {
      this.button.ariaLabel = this.isInWishlist()
        ? this.dataset.removeText
        : this.dataset.addText;
      this.button.classList.toggle('is-active', this.isInWishlist());
      this.classList.remove('hidden');
    }
  }

  customElements.define('wishlist-button', WishlistButton);
}
